<template>
  <div>
    <div v-if="surveysAreLoading">
      <loading></loading>
    </div>
    <div v-else-if="surveysHaveLoaded">
      <div class="centered-row regular-text">
        <div class="outer-container">
          <ProgressBar :current="getQuestionNumber" :total="totalNumberOfPermutations"></ProgressBar>
          <div
            class="line-spacing primary-color bold font-secondary"
          >{{ getQuestionNumber }}/{{ totalNumberOfPermutations }}</div>
          <div class="line-spacing rich-text-editor-custom-css" v-html="studyInfo" />
          <div v-if="showConsidered" class="line-spacing bold">{{ $t('considerVignette') }}</div>
          <div class="line-spacing regular-text">{{ getRatingQuestion }}</div>
          <div v-if="isGeneralBrandSurvey">
            <div
              class="label-spacing"
              v-for="(ratingLabel, idx) in ratingLabels"
              :key="idx"
            >{{ ratingLabel }}</div>
          </div>
          <div class="answers line-spacing">
            <div class="extra-padding">
              <div class="each-answer" v-for="answer in answers">
                <span><b>{{ answer }}</b></span>
              </div>
            </div>
          </div>
          <div class="entire-ratings-component line-spacing">
            <div>
              <div class="rating-container" v-for="rating in ratings">
                <div
                  class="rating-box"
                  v-bind:class="indicateDisabled"
                  @click="ratingClick(rating)"
                >{{ rating }}</div>
              </div>
            </div>
          </div>
          <div v-if="isProspx">
            <div
              class="label-spacing"
              v-for="(ratingLabel, idx) in ratingLabels"
              :key="idx"
            >{{ ratingLabel }}</div>
          </div>
          <FooterBar></FooterBar>
        </div>
      </div>
    </div>
    <div class="centered-row" v-else-if="surveyLoadingError">
      <ErrorPage>
        <div slot="header">{{ surveyNotLoading }}</div>
        <div slot="message">{{ surveyNotLoadingMessage }}</div>
      </ErrorPage>
    </div>
  </div>
</template>

<script>

import http from "../../services/axios"
import {
  COMPLETE_SURVEY,
  GET_BACKEND_URL,
  GET_HTTP_CONFIG,
  LOADING_COMPLETED_FAILURE,
  LOADING_COMPLETED_SUCCESS,
  LOADING_STARTED,
  SET_USER_POSITION_IN_SURVEY,
  USER_POSITION_IN_SURVEY
} from "../../services/constants"
import FooterBar from '../views/FooterBar'
import ErrorPage from "../views/ErrorPage"
import ProgressBar from "../general/ProgressBar"

export default {
  name: 'Survey',

  created () {
    if (this.$store.state.surveyModule.isSurveyPreview) {
      this.setComponentState(this.$store.state.surveyModule.survey)
      this.ifMoreQuestionsToAnswer() ? this.setAnswers() : this.sendUserToDonePage()
    } else {
      http.get(this.$store.getters[GET_BACKEND_URL](`surveys/${this.$route.params.survey_id}`), this.$store.getters[GET_HTTP_CONFIG])
        .then(response => {
          this.setComponentState(response)
          this.ifMoreQuestionsToAnswer() ? this.setAnswers() : this.sendUserToDonePage()
        })
        .catch(err => {
          this.surveyLoadingStatus = LOADING_COMPLETED_FAILURE
        })
    }
  },

  data () {
    return {
      totalNumberOfPermutations: 0,
      questionNumber: 0,
      studyInfo: '',
      ratingQuestion: {},
      permutations: {},
      answers: [],
      maxRating: 0,
      permutationID: 0,
      participantID: 0,
      disableClick: false,
      start: new Date(),
      surveyLoadingStatus: LOADING_STARTED
    }
  },

  components: {
    ProgressBar,
    ErrorPage,
    FooterBar
  },

  methods: {
    setAnswers () {
      const answers = []
      for (let perm in this.permutations[this.questionNumber]['answers']) {
        answers.push(this.permutations[this.questionNumber]['answers'][perm].answer)
      }
      this.answers = answers
      this.permutationID = this.permutations[this.questionNumber]['id']
    },
    updateSurvey () {
      this.setAnswers()
      this.start = new Date()
    },
    setComponentState (response) {
      console.log('res', response)
      let perm = response.data.permutations
      perm.unshift(perm[perm.length - 1])
      let preview = this.$store.state.surveyModule.isSurveyPreview
      this.questionNumber = response.data.currentPermutation
      this.totalNumberOfPermutations = Object.keys(perm).length
      this.studyInfo = response.data.study.studyInfo
      this.ratingQuestions = response.data.study.ratingQuestions
      this.permutations = perm
      this.maxRating = response.data.study.maxRating
      this.participantID = !preview ? response.data.participant.id : 0
      this.surveyLoadingStatus = LOADING_COMPLETED_SUCCESS
    },
    sendUserToDonePage () {
      let payload = {
        postPrelimToServer: false,
        sendToAdditionalQuestion: false,
      }
      this.$store.dispatch(USER_POSITION_IN_SURVEY, payload)
    },
    ifMoreQuestionsToAnswer () {
      return this.questionNumber < this.totalNumberOfPermutations
    },
    createObjectToPost (numberSelected) {
      const elapsed = new Date() - this.start;
      const objToPost = {}
      objToPost['rating'] = numberSelected
      objToPost['responseTime'] = elapsed
      return objToPost
    },
    ratingClick (numberSelected) {
      if (!this.disableClick) {

        this.disableClick = true
        this.questionNumber += 1
        const objToPost = this.createObjectToPost(numberSelected)

        if (this.ifMoreQuestionsToAnswer()) {
          this.updateSurvey()
        }

        if (this.$store.state.surveyModule.isSurveyPreview || this.questionNumber === 1) {
          if (this.ifMoreQuestionsToAnswer()) {
            this.disableClick = false
          } else {
            this.$store.commit(SET_USER_POSITION_IN_SURVEY, { postPrelimToServer: false })
          }
        } else {
          return http.post(this.$store.getters[GET_BACKEND_URL](`surveys/${this.permutationID}/${this.participantID}`), objToPost).then(response => {
            if (this.ifMoreQuestionsToAnswer()) {
              this.disableClick = false
            } else if (!this.hasPostPresentationOrQuestion) {
              this.$store.dispatch(COMPLETE_SURVEY, this.$route.params.survey_id)
            } else {
              this.$store.commit(SET_USER_POSITION_IN_SURVEY, { postPrelimToServer: false })
            }
          }).catch(err => {
            console.error(err)
          })
        }
      }
    }
  },
  computed: {
    ratings () {
      return this.$t('answerNumbers').slice(0, this.maxRating);
    },
    surveysAreLoading () {
      return this.surveyLoadingStatus === LOADING_STARTED
    },
    surveysHaveLoaded () {
      return this.surveyLoadingStatus === LOADING_COMPLETED_SUCCESS
    },
    surveyLoadingError () {
      return this.surveyLoadingStatus === LOADING_COMPLETED_FAILURE
    },
    surveyNotLoadingMessage () {
      return "For some reason, it looks like the Survey couldnt load"
    },
    surveyNotLoading () {
      return "Server Error"
    },
    showConsidered () {
      return this.$store.state.surveyModule.survey.data.study.id === 4509
    },
    getQuestionNumber () {
      return this.ifMoreQuestionsToAnswer() ? this.questionNumber + 1 : this.totalNumberOfPermutations
    },
    indicateDisabled () {
      return {
        "indicate-disabled": this.disableClick
      }
    },
    leastImportant () {
      return this.ratingQuestions[0].lowEnd
    },
    intermediateValues () {
      return this.ratingQuestions[0].intermediate
    },
    mostImportant () {
      return this.ratingQuestions[0].highEnd
    },
    ratingLabels () {
      const labels = []
      labels.push(`1 = ${this.leastImportant}`)
      if (this.intermediateValues) {
        this.intermediateValues.split(';').forEach((keyValuePair) => {
          const arr = keyValuePair.split("=")
          const value = arr[0]
          const label = arr[1]
          if (label.length > 0) {
            labels.push(`${value} = ${label}`)
          }
        })
      }
      labels.push(`${this.maxRating} = ${this.mostImportant}`)
      return labels
    },
    getRatingQuestion () {
      return this.ratingQuestions[0].ratingQuestion
    },
    isProspx () {
      return this.$store.state.surveyModule.survey.data.study.brand === "prospx"
    },
    isGeneralBrandSurvey () {
      return !this.$store.state.surveyModule.survey.data.study.brand
    },
    surveyData () {
      return this.$store.state.surveyModule.survey.data
    },
    hasPostPresentationOrQuestion () {
      return this.surveyData.study.postPresentation || this.surveyData.study.optionalQuestion
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../scss/main";

.extra-padding {
  padding-top: 5px;
  padding-bottom: 5px;
}

.outer-container {
  padding-top: 5%;
  width: 80%;
  max-width: 1024px;
}

.regular-text {
  font-size: 16px;
}

.primary-color {
  color: $red-2;
}

.bold {
  font-weight: bold;
}

.line-spacing {
  padding-top: 15px;
  padding-bottom: 15px;
}

.each-answer {
  padding-top: 10px;
  padding-bottom: 10px;
}

.label-spacing {
  padding-top: 5px;
  padding-bottom: 5px;
}

.rating-container {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}

.rating-box {
  display: inline-flex;
  width: 50px;
  height: 50px;
  color: $white-1;
  background-color: $cyan-1;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.indicate-disabled {
  /*cursor: wait;*/
  /*opacity: .5;*/
}

.entire-ratings-component {
  display: inline-block;
  position: relative;
  direction: ltr;
}

.answers {
  padding-left: 7%;
}

.least-important {
  display: inline-block;
}

.most-important {
  display: inline-block;
  position: absolute;
  right: 10px;
}
</style>
